import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import PageMeta from '../../components/common/PageMeta';
import { InquiriesWorkspace } from '../../features/inquiries/InquiriesWorkspace';
import { EVENT_INQUIRIES } from '../../features/inquiries/kind';
import { FillPage } from '../../layout/FillPage';

export const SPECIAL_EVENTS_BASE = '/special-events';

const recordPath = (id: number) => `${SPECIAL_EVENTS_BASE}/${id}`;

/** Event inquiries: /special-events (list) and /special-events/:id (record). */
export default function SpecialEvents() {
  const { id } = useParams<{ id?: string }>();
  const { search } = useLocation();
  const valid = id != null && /^\d+$/.test(id) && Number(id) > 0;
  if (id != null && !valid) {
    return <Navigate to={`${SPECIAL_EVENTS_BASE}${search}`} replace />;
  }
  return (
    <FillPage>
      <PageMeta title="AskArthur | Events" description="Event inquiries" />
      <InquiriesWorkspace
        config={EVENT_INQUIRIES}
        selectedId={valid ? Number(id) : null}
        listPath={SPECIAL_EVENTS_BASE}
        recordPath={recordPath}
      />
    </FillPage>
  );
}
